<template>
  <v-text-field
    ref="formattedNumberField"
    :class="`formatted-number-field number-without-spinners ${blur ? 'blur' : ''}`"
    :label="label"
    :value="blur ? blurValue : formattedValue"
    @input="valueInput"
    :disabled="disabled"
    :hide-details="hideDetails"
    :append-icon="appendIcon"
    :append-outer-icon="appendOuterIcon"
    :background-color="backgroundColor"
    :clearable="clearable"
    :dense="dense"
    :error="error"
    :error-messages="errorMessages"
    :prepend-icon="prependIcon"
    :prepend-inner-icon="prependInnerIcon"
    :readonly="readonly || blur"
    :rules="formattedValueRules"
    :suffix="suffix"
    :hint="hint"
    :persistent-hint="persistentHint"
    :outlined="outlined"
    @click="$emit('click', $event)"
    @mousedown="$emit('mousedown', $event)"
    @keydown="$emit('keydown', $event)"
    @keypress="keypress"
    @keyup="$emit('keyup', $event)"
    @blur="formatValue"
  ></v-text-field>
</template>

<script>
import { Convert } from './convert'

export default {
  name: 'FormattedNumberField',
  props: {
    value: Number,
    label: String,
    disabled: Boolean,
    'hide-details': [Boolean, String],
    'append-icon': String,
    'append-outer-icon': String,
    'background-color': String,
    clearable: Boolean,
    dense: Boolean,
    error: Boolean,
    'error-messages': [Number, String],
    'prepend-icon': String,
    'prepend-inner-icon': String,
    readonly: Boolean,
    rules: Array,
    suffix: String,
    hint: String,
    'persistent-hint': [Boolean, String],
    blur: Boolean,
    outlined: Boolean
  },
  data() {
    return {
      numberValue: null,
      formattedValue: null
    }
  },
  computed: {
    blurValue() {
      return !this.formattedValue ? '#' : this.formattedValue.toString().replace(/\d/g, '#')
    },
    formattedValueRules() {
      return this.blur ? [] : this.rules
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        //  Only do something here if the numeric value changes EXTENALLY. We're keeping
        //  numberValue up to date with the last known value internally. This is really only
        //  here to handle initial display of the value and maybe if there was a control that
        //  modified the value elsewhere on the form.
        if (this.value !== this.numberValue) {
          this.numberValue = this.value
          this.formatValue()
        }
      }
    }
  },
  methods: {
    valueInput(stringValue) {
      this.formattedValue = stringValue
      if (stringValue === '') {
        this.numberValue = null
        this.$emit('input', null)
      }
      if (stringValue) {
        stringValue = stringValue.replace(/,/g, '')
      }
      this.numberValue = Convert.tryToFloat(stringValue)
      if (this.numberValue !== null) {
        this.$emit('input', this.numberValue)
      }
    },
    keypress(evt) {
      //  Filter to number characters
      var charCode = evt.which ? evt.which : evt.keyCode
      if ((charCode >= 48 && charCode <= 57) || charCode === 45 || charCode === 46) {
        return true
      }
      evt.preventDefault()
    },
    formatValue() {
      if (this.value !== null && this.value !== undefined) {
        this.formattedValue = this.value.toLocaleString('en-US')
      } else {
        this.formattedValue = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.number-without-spinners ::v-deep input[type='number'] {
  -moz-appearance: textfield;
}
.number-without-spinners ::v-deep input::-webkit-outer-spin-button,
.number-without-spinners ::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

.v-input.formatted-number-field.number-without-spinners.blur::v-deep input[type='text'] {
  color: transparent;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}
</style>
